import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventGallery extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventGallery';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            title: null,
            banner: null,
            src: null,
        }
    }

    static setupInstance(data, {models}) {
        if (data.photos) {
            data.photos = data.photos.map((p) => new models.api.GalleryItem(p))
        } else {
            data.photos = [];
        }
        return data
    }
}

const servicePath = 'f-gallery';
const servicePlugin = makeServicePlugin({
    Model: EventGallery,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin